import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { uiChangeSkladName } from '../../../../actions/ui';
import WarehouseCommonApi from '../../../../API/warehouse/common-api';
import to_right from '../../../../assets/media/icons/to_right.svg';
import { Column, ImagesViewer, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Icon } from '../../../../components/Basic/Elements';
import { Input, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine, TablePagination } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import MarketsPairs from '../../../../components/Common/Elements/MarketsPairs';
import BarcodesBlock from '../../../../components/Common/Input/Barcodes';
import AddToWarehouse from '../../../../components/Warehouse/AddToWarehouseButton';
import WarehouseAddressInput from '../../../../components/Warehouse/WarehouseAddressInput';
import { SKLADS_WAREHOUSE, TO_PRODUCT } from '../../../../constans';
import styles from './styles.module.scss';
import WarehouseStepperInput from './WarehouseStepperInput';



const width = ['90px', '400px', '150px', '190px', '250px', '110px', '110px', '400px', '300px', '50px'];
//const B_WHITE_PRODUCT_LINK = slug => `https://b-white.ru/products/${slug}`;

const FILTER = {
  0: 'all',
  1: 'instock',
  2: 'nullstock',
  3: 'reserve',
  4: 'inventory',
  5: 'notfound',
};



function ProductsTable() {
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState('');
  const [show, setShow] = useState(50);
  const [empty, setEmpty] = useState(false);
  const [remove, setRemove] = useState({ open: false, id: null });

  const [warehouse, setWarehouse] = useState({});
  const [byId, setById] = useState({});
  const [ids, setIds] = useState([]);

  const user = useSelector((store) => store.user);
  const allProviders = useSelector((store) => store.providers);
  const { skladName } = useSelector((store) => store.ui);

  const [count, setCount] = useState(0);
  const [tab, setTab] = useState(0);
  const [page, setPage] = useState(1);
  const [isInventory, setIsInventory] = useState(false);
  const [entriedProductsMap, setEntriedProductsMap] = useState({});

  const dispatch = useDispatch();

  let [providerList, setProviderList] = useState([]);

  const onChangePage = (v) => {
    setPage(v);
  };
  const onChangeTab = (n) => {
    setTab(n);
  };

  const searchProducts = async () => {
    if (!providerList[tab]) {
      return;
    }
    await WarehouseCommonApi.getProviderProducts({
      data: {
        search,
        limit: parseInt(show),
        page: page,
        providerId: providerList[tab].id,
        skladName: skladName.short_name,
      }
    }).then((r) => {
      const { products = [], warehouse = {}, count = 0, addresses } = r;
      const byIds = {};
      const id = products.map((item) => item.sku);

      products.forEach((item) => (byIds[item.sku] = item));

      setEntriedProductsMap(r.entriedProductsMap);
      setWarehouse(warehouse);
      setById(byIds);
      setIds(id);
      setCount(count);
    });
  };

  const saveEntries = (entriedProduct) => {
    setEntriedProductsMap({ ...entriedProductsMap, [entriedProduct.warehouse_id]: entriedProduct });
  };

  useEffect(() => {
    searchProducts().then();
  }, [search, page, tab, providerList]);

  // { id: null, name: 'all', text: 'Все поставщики' }, // 0
  useEffect(() => {
    setProviderList(allProviders.filter(p => skladName.short_name === 'msk' ? true : p.sklads[skladName.short_name]).filter(p => !p.hide).toSpliced(1, 0, { id: null, name: 'Все поставщики' }));
  }, [skladName.short_name]);

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            // flexRows={true}
            open_tab={tab}
            tabs={providerList.map((item) => item.name)}
            style_tab={styles.style_tab}
            style_tabs={styles.style_tabs}
            onChange={onChangeTab}
          />
        </Row>
        <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row>
          <div>
            <Select
              label="Показать на странице"
              select={show}
              list={['50', '100', '150', '200', '500', '1000']}
              onSelect={(v) => setShow(v)}
              width="100px"
              style={{ marginRight: '15px' }}
            />
          </div>
          <div>
            <Select
              label="Город"
              select={skladName}
              list={SKLADS_WAREHOUSE.filter((item) => user.sklads[item.short_name])}
              valueFn={(p) => p.name}
              onSelect={(v) => dispatch(uiChangeSkladName(v))}
              width="200px"
              style={{ marginRight: '15px' }}
            />
          </div>
        </Row>
      </WhiteBlock>
      <Table styles={styles.stocks_table}>
        <TableHeader whiteHeader={true} styles={styles.table_line}>
          <HeaderTitle width={width[0]}>Фото</HeaderTitle>
          <HeaderTitle width={width[2]}>Артикул</HeaderTitle>

          <HeaderTitle width={width[1]}>Название</HeaderTitle>
          <HeaderTitle width={width[4]}>Штрихкод</HeaderTitle>

          <HeaderTitle width={width[2]} centerText>
            Мой Склад
          </HeaderTitle>

          <HeaderTitle width={width[9]} />
          {isInventory && (
            <HeaderTitle width={width[3]} centerText>
              Инвентаризация
            </HeaderTitle>
          )}

          <HeaderTitle width={width[3]} centerText>
            Текущие занесение
          </HeaderTitle>

          <HeaderTitle width={width[2]}>Адрес на складе</HeaderTitle>

          <HeaderTitle width={width[2]} centerText>
            Артикул на складе
          </HeaderTitle>

          <HeaderTitle width={width[1]}>Название на складе</HeaderTitle>
          <HeaderTitle width={width[4]}>Размещение на площадках</HeaderTitle>
        </TableHeader>
        {ids.map((id) => {
          const item = byId[id];
          let images =
            item.images.local?.length > 0
              ? item.images.local
              : item.images.foreign?.length > 0
                ? item.images.foreign
                : ['https://api.samsonopt.ru/goods/110983/b2fadb432e3ec30f0ccd03c3b2f624e1_x.jpg'];

          const warehouse_product = warehouse[item.warehouse_id] || null;
          console.log(warehouse_product)
          const is_map = !!warehouse_product;

          let name_provider = providerList.find((p) => p.id === item.provider_id)?.name;

          let entriedProduct = entriedProductsMap[item.sku];

          return (
            <TableLine white={true} key={item.sku}>
              <TableCell width={width[0]}>
                <ImagesViewer images={images} />
              </TableCell>
              <TableCell width={width[2]}>
                <Column>
                  <div>{item.sku}</div>

                  <Text style={{ color: '#AE1213' }}>{tab === 0 ? name_provider : ''}</Text>
                </Column>
              </TableCell>
              <TableCell width={width[1]} fontSize="14px">
                <Column>
                  {item.name}
                  <TextGrey style={{ width: '100%', fontSize: '12px' }}>{item.category}</TextGrey>
                </Column>
              </TableCell>

              <TableCell width={width[4]} fontSize="14px">
                <BarcodesBlock barcodes={item.barcodes} />
              </TableCell>

              <TableCell width={width[2]} style={{ justifyContent: 'flex-end' }}>
                <AddToWarehouse
                  skladName={skladName.short_name}
                  providerId={providerList[tab].id}
                  id={item.sku}
                  isSource={item.warehouse_id}
                  isProvider={true}
                  onChangeWarehouse={(p) => setWarehouse({ ...warehouse, [p.id]: p })}
                  onChangeProduct={(p) =>
                    setById({ ...byId, [p.sku]: { ...byId[p.sku], warehouse_id: p.warehouse_id } })
                  }
                  onChangeEntry={saveEntries}
                />
              </TableCell>
              <TableCell width={width[9]} style={{ justifyContent: 'flex-end' }}>
                {is_map && <Icon src={to_right} />}
              </TableCell>

              <>
                <TableCell width={width[3]} fontSize="14px" center>
                  {entriedProduct && (
                    <WarehouseStepperInput
                      item={warehouse_product}
                      entryItem={entriedProduct}
                      save={saveEntries}
                      onChange={(item) => {
                        console.log(item);
                      }}
                    />
                  )}
                </TableCell>
                <TableCell width={width[2]}>
                  {is_map && (
                    <WarehouseAddressInput
                      warehouseId={warehouse_product.id}
                      address={warehouse_product.sklad_data?.[skladName.short_name]?.address}
                      width={'100px'}
                    //  onChange={(v) => setProduct(v)}
                    />
                  )}
                </TableCell>
                <TableCell width={width[2]} center>
                  {is_map && warehouse_product.id}
                </TableCell>

                <TableCell widtch={width[1]} fontSize="14px">
                  {is_map && (
                    <Column>
                      <Link to={TO_PRODUCT(warehouse_product.id)} target="_blank" className={styles.link}>
                        {warehouse_product.name}
                      </Link>
                      <TextGrey style={{ width: '100%', fontSize: '12px' }}>{warehouse_product.category}</TextGrey>
                    </Column>
                  )}
                </TableCell>
              </>

              <TableCell width={width[4]} fontSize="14px" style={{ justifyContent: 'flex-end' }}>
                <MarketsPairs market={item.market} width={'25px'} />
              </TableCell>
            </TableLine>
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </>
  );
}

export default ProductsTable;
